import script from "./project-application-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./project-application-list.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__